import { CrudCollectionPage } from "./CrudCollectionPage";
import { hasPermission } from "../core/session";

export function ChargesPage() {
  return (
    <CrudCollectionPage
      label="Charges"
      singular="Charge"
      endpoint="/charges"
      icon="nav_profiles"
      canCreate={hasPermission("config.charges.create")}
      canUpdate={hasPermission("config.charges.update")}
      advancedSearch={false}
      createDefaults={{
        categoryId: null,
        name: "",
        description: "",
        type: "Misdemeanor",
        fine: 0,
        jailTime: 0,
        points: 0,
        hasAccessory: false,
        hasAccomplice: false,
        deniesParole: false,
        accessoryDescription: "",
        accessoryTime: 0,
        accessoryFine: 0,
        accompliceDescription: "",
        accompliceTime: 0,
        accompliceFine: 0,
      }}
      fields={[
        { key: "name", label: "Name" },
        { key: "categoryId", label: "Category ID", type: "number" },
        { key: "categoryName", label: "Category", readOnly: true },
        { key: "description", label: "Description" },
        { key: "type", label: "Type" },
        { key: "fine", label: "Fine", type: "number" },
        { key: "jailTime", label: "Jail Time", type: "number" },
        { key: "points", label: "Points", type: "number" },
        { key: "hasAccessory", label: "Has accessory", type: "checkbox" },
        { key: "accessoryDescription", label: "Accessory description" },
        { key: "accessoryTime", label: "Accessory time", type: "number" },
        { key: "accessoryFine", label: "Accessory fine", type: "number" },
        { key: "hasAccomplice", label: "Has accomplice", type: "checkbox" },
        { key: "accompliceDescription", label: "Accomplice description" },
        { key: "accompliceTime", label: "Accomplice time", type: "number" },
        { key: "accompliceFine", label: "Accomplice fine", type: "number" },
        { key: "deniesParole", label: "Denies parole", type: "checkbox" },
      ]}
      itemTitle={(item) => value(item.name)}
      itemDescription={(item) =>
        `${value(item.categoryName)} • $${value(item.fine)} • ${value(item.jailTime)} month(s)`
      }
      prepareWrite={(item) => ({
        categoryId: nullableNumber(item.categoryId),
        name: value(item.name),
        description: value(item.description),
        type: value(item.type) || "Misdemeanor",
        fine: number(item.fine),
        jailTime: number(item.jailTime),
        points: number(item.points),
        hasAccessory: Boolean(item.hasAccessory),
        hasAccomplice: Boolean(item.hasAccomplice),
        deniesParole: Boolean(item.deniesParole),
        accessoryDescription: value(item.accessoryDescription),
        accessoryTime: number(item.accessoryTime),
        accessoryFine: number(item.accessoryFine),
        accompliceDescription: value(item.accompliceDescription),
        accompliceTime: number(item.accompliceTime),
        accompliceFine: number(item.accompliceFine),
      })}
    />
  );
}

function value(input: unknown): string {
  return typeof input === "string" || typeof input === "number"
    ? String(input)
    : "";
}
function number(input: unknown): number {
  return Math.max(0, Number(input) || 0);
}
function nullableNumber(input: unknown): number | null {
  const output = Number(input);
  return Number.isSafeInteger(output) && output > 0 ? output : null;
}
